import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import {
  pdf_form_formats,
  pdfSizes,
} from "../../data/buildingPermit/fieldDatas";
import { useDispatch } from "react-redux";
import { handleDownloadNoc } from "../../store/actions/dataActions";
import { LoadingButton } from "@mui/lab";

const SelectDownloadFileSIzeModal = ({ open, setOpen }) => {
  const [selectedFormat, setSelectedFormat] = useState("pdf");
  const [selectedSize, setSelectedSize] = useState("letter");
  const [downloadLoading, setDownloadLoading] = useState(false);

  const dispatch = useDispatch();

  const handleConfirm = async () => {
    try {
      setDownloadLoading(true);
      await dispatch(handleDownloadNoc(selectedFormat, selectedSize));
    } catch (e) {
    } finally {
      setDownloadLoading(false);
      setOpen(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        if (downloadLoading) {
          return;
        } else {
          setOpen(false);
        }
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Select Download Options
        </Typography>

        {/* Format Selection */}
        <FormControl
          fullWidth
          variant="filled"
          sx={{ mb: 2 }}
          disabled={downloadLoading}
        >
          <InputLabel>Format</InputLabel>
          <Select
            value={selectedFormat}
            onChange={(e) => setSelectedFormat(e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  marginTop: "1.5px",
                  maxHeight: 150, // Set the desired max height for the dropdown menu
                  width: "auto",
                  maxWidth: "100%",
                },
              },
            }}
          >
            {pdf_form_formats.map((format) => (
              <MenuItem key={format.value} value={format.value}>
                {format.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* PDF Size Selection */}
        <FormControl
          fullWidth
          variant="filled"
          sx={{ mb: 2 }}
          disabled={downloadLoading}
        >
          <InputLabel>PDF Size</InputLabel>
          <Select
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  marginTop: "1.5px",
                  maxHeight: 150, // Set the desired max height for the dropdown menu
                  width: "auto",
                  maxWidth: "100%",
                },
              },
            }}
          >
            {pdfSizes
              .filter((size) => !size.divider)
              .map((size) => (
                <MenuItem key={size.value} value={size.value}>
                  {size.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button
            disabled={downloadLoading}
            onClick={() => setOpen(false)}
            variant="outlined"
          >
            Cancel
          </Button>
          <LoadingButton
            loading={downloadLoading}
            onClick={handleConfirm}
            variant="contained"
          >
            Download
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(SelectDownloadFileSIzeModal);
